export default __webpack_public_path__ + "static/media/purpleCloudFormation.830a7b09.svg";